import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";

export function useShortenedParagraph(
  paragraph: MaybeRef<ILegalTextParagraph>
) {
  const shortenedParagraph = computed(() =>
    unref(paragraph).paragraph.replace("Art. ", "").replace(/§+/, "")
  );

  return {
    shortenedParagraph,
  };
}
